import React, { useCallback, useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

interface Item {
  [key: string]: any;
}

interface InputDropSearchProps {
  data: Item[];
  label: string;
  value?: any;
  selectName1: string;
  selectName2?: string;
  value2Name?: string;
  noMgs?: string;
  extraMsg?: string;
  selectValue: string;
  onChange: (event: {
    target: { name: string; value: any; valueTitle: string; value2: any };
  }) => void;
  onSearch: (value: string) => void;
  name: string;
  isDisable?: boolean;
  errors?: boolean;
  errormessage?: string;
}

const InputDropSearch: React.FC<InputDropSearchProps> = ({
  value,
  data,
  label,
  selectName1,
  selectName2,
  value2Name,
  selectValue,
  onChange,
  onSearch,
  name,
  isDisable = false,
  errors,
  errormessage,
  noMgs,
  extraMsg,
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [select, setSelect] = useState<{ name: string; id: any }>({
    name: "",
    id: "",
  });

  const handleOpen = useCallback(() => {
    if (!isDisable) setOpen((prevOpen) => !prevOpen);
  }, [isDisable]);

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const searchTerm = e.target.value;
      setSearch(searchTerm);
      onSearch(searchTerm);
    },
    [onSearch]
  );

  const handleSelect = useCallback(
    (item: Item) => {
      const selectedItem = {
        name: item.name,
        id: item.id,
      };
      
      
      setSelect(selectedItem);
      onChange({
        target: {
          name,
          value: item.id,
          valueTitle: item.name,
          value2: item?.item,
        },
      });
      setOpen(false);
    },
    [name, onChange]
  );

  useEffect(() => {
    if (value) {
      const selectedItem = data.find((item) => item[selectValue] === value);
      setSelect({
        name: selectedItem?.[selectName1] || "",
        id: value,
      });
    } else {
      setSelect({ name: "", id: "" });
    }
  }, [value, data, selectName1, selectValue]);

  return (
    <div className="form_search">
      <label>{label}</label>
      <div
        className={`search_select ${errors ? "mandatory_input" : ""}`}
        onClick={handleOpen}
      >
        <div className="placeholder">
          {select.name !== "" ? select.name : "Select"}
        </div>
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </div>
      {open && (
        <ul>
          <li>
            <input
              type="text"
              onChange={handleSearch}
              value={search}
              placeholder="Search here"
            />
          </li>
          {data.map((item, i) => (
            <li
              key={i}
              onClick={() =>
                handleSelect({
                  id: item[selectValue],
                  name: item[selectName1],
                  item,
                })
              }
            >
              <span>{item[selectName1]}</span>
              <span>
                {selectName2 && item[selectName2]
                  ? item[selectName2]
                  : noMgs || ""}
                {extraMsg || ""}
              </span>
            </li>
          ))}
        </ul>
      )}
      {errors && (
        <label className="form__label__error">
          {errormessage ? errormessage : `${label} is mandatory`}
        </label>
      )}
    </div>
  );
};

export default InputDropSearch;
